import React from "react";
import { Text } from "components";
import { Stage } from "./_shared";

export const typographyEntries = [
  {
    id: "text", name: "Text / Heading", group: "Typography", status: "live",
    description: "Typography primitive tied to brand tokens — one place for type instead of ad-hoc fontSize/fontFamily.",
    props: [
      { name: "variant", type: "'display'|'h1'|'h2'|'h3'|'eyebrow'|'body'|'caption'|'code'", default: "'body'", description: "Style" },
      { name: "tone", type: "'default'|'muted'|'accent'", default: "'default'", description: "Color" },
      { name: "as", type: "element", description: "Tag override" },
    ],
    variants: [
      { label: "Scale", render: () => <Stage width={420}><div style={{ display: "grid", gap: 8 }}><Text variant="display">Display</Text><Text variant="h1">Heading 1</Text><Text variant="h2">Heading 2</Text><Text variant="h3">Heading 3</Text><Text variant="eyebrow">Eyebrow label</Text><Text variant="body">Body copy — the default for paragraphs and UI text.</Text><Text variant="caption">Caption / metadata</Text><Text variant="code">code.snippet()</Text></div></Stage> },
    ],
    code: `import { Text } from "components";

<Text variant="display">Display</Text>
<Text variant="h2">Heading 2</Text>
<Text variant="body" tone="muted">Body copy</Text>
<Text variant="eyebrow">Eyebrow label</Text>
<Text variant="code">code.snippet()</Text>`,
  },
];
